import { render, staticRenderFns } from "./material-management.vue?vue&type=template&id=25edd881&scoped=true&"
import script from "./material-management.vue?vue&type=script&lang=js&"
export * from "./material-management.vue?vue&type=script&lang=js&"
import style0 from "./material-management.vue?vue&type=style&index=0&id=25edd881&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25edd881",
  null
  
)

export default component.exports